// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debounce(func, wait) {
    let timeout;
    return (...args) => {
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => func(...args), wait);
    };
}
export { debounce };
